




import { Component, Vue, Prop } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_workRelationPaycheckSums, GQL_workRelationPaycheckSumsVariables, GQL_workRelationPaycheckSums_workRelation_paycheckSums } from '@/queries/__generated__/workRelationPaycheckSums';
import cloneDeep from 'lodash/cloneDeep';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';

const GET_PAYCHECK_SUMS = gql`
  query workRelationPaycheckSums($workRelationId: ID!, $year: Int!, $untilDate: Date!) {
    workRelation(id: $workRelationId) {
      id
      paycheckSums(year: $year, untilDate: $untilDate) {
        number
        sum
        description
        altinnFordel
        calculationType
      }
    }
  }
`;

@Component
export default class PaycheckSumsFetcher extends Vue {
  @SmartQuery<PaycheckSumsFetcher, GQL_workRelationPaycheckSums, GQL_workRelationPaycheckSumsVariables>({
    query: GET_PAYCHECK_SUMS,
    fetchPolicy: 'no-cache',
    variables() {
      return {
        workRelationId: this.paycheck.workRelation.id,
        year: parseInt(this.$dayjs.strict(this.paycheck.endDate).format('YYYY')),
        untilDate: this.paycheck.endDate,
      };
    },
    update(data) {
      const sums = cloneDeep(data.workRelation?.paycheckSums || []);

      type Line = {
        number: number;
        id: string | null;
        sum: Decimal;
      }

      sums.forEach(sum => {
        sum.sum = sum.sum.minus(
          (this.paycheck.paycheckLines as Line[])
            .filter(line => line.number === sum.number)
            .filter(line => !!line.id)
            .reduce((sum, line) => sum.add(line.sum), new Decimal(0)),
        );
      });

      this.$emit('fetched', sums);

      return sums;
    },
  }) private paycheckSums!: GQL_workRelationPaycheckSums_workRelation_paycheckSums[];

  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;

  public refetchPaycheckSums(): void {
    this.$apollo.queries.paycheckSums.refetch();
  }
}
